import makeStyles from "@mui/styles/makeStyles";
import { InfoTooltipProps } from "./InfoTooltip.types";

export const useTooltipStyles = makeStyles((theme) => ({
  arrow: (props: InfoTooltipProps) => ({
    color:
      props.bgColor === "grey"
        ? theme.palette.grey[100]
        : theme.palette.common.white,
  }),
  tooltip: (props: InfoTooltipProps) => ({
    padding: 16,
    backgroundColor:
      props.bgColor === "grey"
        ? theme.palette.grey[100]
        : theme.palette.common.white,
    color: "inherit",
    boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.2)",
  }),
}));

export const useStyles = makeStyles((theme) => ({
  infoIcon: {
    width: 20,
    height: 20,
    marginBottom: 8,
  },
  button: {
    width: 20,
    height: 20,
    marginLeft: 12,
    padding: 0,
    background: "transparent",
    border: 0,
    outline: 0,
    transform: (props: InfoTooltipProps) =>
      props.isError ? "rotate(180deg)" : "none",
    "&:hover > svg": {
      color: (props: InfoTooltipProps) =>
        props.isError ? theme.palette.red.main : theme.palette.primary.main,
    },
    "&:focus > svg": {
      color: theme.palette.primary.main,
    },
    cursor: "pointer",
    zIndex: 1,
  },
  buttonSmall: {
    width: 16,
    height: 16,
  },
  buttonTiny: {
    width: 10,
    height: 10,
  },
  icon: {
    color: (props: InfoTooltipProps) =>
      props.isError ? theme.palette.red.main : theme.palette.grey[900],
    fontSize: 20,
  },
  iconSmall: {
    fontSize: 16,
  },
  iconTiny: {
    fontSize: 13,
  },
  hideLinkToMakeFocusBackToIcon: {
    position: "absolute",
    opacity: 0,
  },
  closeButton: {
    height: "20px !important",
    padding: "0 !important",
    fontWeight: "normal",
    fontSize: "14px !important",
  },
}));
